


// import React, { useState, useEffect } from "react";

// const PreviousExperience = ({ goToTab, setExperienceData, experienceData }) => {
//   const [formData, setFormData] = useState({
//     srNo: "",
//     organization: "",
//     monthYearFrom: "",
//     monthYearTo: "",
//     reasonForLeaving: "",
//     experienceLetterProvided: false,
//   });

//   const [dataList, setDataList] = useState([]);

// useEffect(() => {
//   setFormData((prev) => ({
//     ...prev,
//     srNo: dataList.length + 2, // considering first one is in form
//   }));
// }, [dataList]);



//  useEffect(() => {
//    if (
//      experienceData &&
//      Array.isArray(experienceData) &&
//      experienceData.length > 0
//    ) {
//      const formatted = experienceData.map((item, index) => ({
//        srNo: index + 1,
//        organization: item.previous_company_worked || "",
//        monthYearFrom: item.month_year_from || "",
//        monthYearTo: item.month_year_to || "",
//        reasonForLeaving: item.reason_for_leaving || "",
//        experienceLetterProvided: item.experience_letter_provided || false,
//      }));

//      setFormData({ ...formatted[0] }); // Display first in input
//      setDataList(formatted.slice(1)); // Others in table
//    }
//  }, [experienceData]);



//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

// const handleAdd = () => {
//   if (
//     !formData.organization ||
//     !formData.monthYearFrom ||
//     !formData.monthYearTo ||
//     !formData.reasonForLeaving
//   ) {
//     alert("Please fill all fields before adding.");
//     return;
//   }

//  const newItem = {
//    ...formData,
//    srNo: dataList.length + 2, // +2 because one record is already in form
//  };


//   const updatedList = [newItem, ...dataList];
//   setDataList(updatedList);
//   setExperienceData(updatedList); // send to parent

//   // Reset form
//  setFormData({
//    srNo: dataList.length + 2, // pre-fill next srNo
//    organization: "",
//    monthYearFrom: "",
//    monthYearTo: "",
//    reasonForLeaving: "",
//    experienceLetterProvided: false,
//  });
// };


//   return (
//     <div className="container my-4">
//       <h5>Previous Experience Details</h5>
//       <div className="table-responsive">
//         <table className="table table-bordered">
//           <thead>
//             <tr>
//               <th>Sr.No</th>
//               <th>Organization</th>
//               <th>Month/Year From</th>
//               <th>Month/Year To</th>
//               <th>Reason for Leaving</th>
//               <th>Experience Letter Provided</th>
//               <th>Action</th>
//             </tr>
//           </thead>
//           <tbody>
//             {dataList.map((data, index) => (
//               <tr key={index}>
//                 <td>{data.srNo}</td>
//                 <td>{data.organization}</td>
//                 <td>{data.monthYearFrom}</td>
//                 <td>{data.monthYearTo}</td>
//                 <td>{data.reasonForLeaving}</td>
//                 <td className="text-center">
//                   <input
//                     type="checkbox"
//                     checked={data.experienceLetterProvided}
//                     readOnly
//                   />
//                 </td>
//                 <td>--</td>
//               </tr>
//             ))}
//             <tr>
//               <td>
//                 <input
//                   className="form-control"
//                   value={formData.srNo}
//                   disabled
//                 />
//               </td>
//               <td>
//                 <input
//                   className="form-control"
//                   name="organization"
//                   value={formData.organization}
//                   onChange={handleChange}
//                 />
//               </td>
//               <td>
//                 <input
//                   className="form-control"
//                   type="date" // this ensures value is always in YYYY-MM-DD
//                   name="monthYearFrom"
//                   value={formData.monthYearFrom}
//                   onChange={handleChange}
//                 />
//               </td>
//               <td>
//                 <input
//                   className="form-control"
//                   type="date" // ensures YYYY-MM-DD
//                   name="monthYearTo"
//                   value={formData.monthYearTo}
//                   onChange={handleChange}
//                 />
//               </td>

//               <td>
//                 <input
//                   className="form-control"
//                   name="reasonForLeaving"
//                   value={formData.reasonForLeaving}
//                   onChange={handleChange}
//                 />
//               </td>
//               <td className="text-center">
//                 <input
//                   type="checkbox"
//                   name="experienceLetterProvided"
//                   checked={formData.experienceLetterProvided}
//                   onChange={handleChange}
//                 />
//               </td>
//               <td>
//                 <button className="btn btn-primary btn-sm" onClick={handleAdd}>
//                   Add
//                 </button>
//               </td>
//             </tr>
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default PreviousExperience;


import React, { useState, useEffect } from "react";

const PreviousExperience = ({ goToTab, setExperienceData, experienceData }) => {
  const emptyForm = {
    organization: "",
    monthYearFrom: "",
    monthYearTo: "",
    reasonForLeaving: "",
    experienceLetterProvided: false,
  };

  const [formData, setFormData] = useState({
    ...emptyForm,
  });

  const [dataList, setDataList] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});

  const isFutureDate = (value) => {
    if (!value) return false;
    const enteredDate = new Date(value);
    if (Number.isNaN(enteredDate.getTime())) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return enteredDate > today;
  };

useEffect(() => {
  if (!Array.isArray(experienceData) || experienceData.length === 0) {
    setDataList([]);
    setFormData(emptyForm);
    return;
  }

  const normalizedRows = experienceData.map((exp, index) => ({
    srNo: index + 1,
    organization: exp.previous_company_worked || exp.organization || "",
    monthYearFrom: exp.month_year_from || exp.monthYearFrom || "",
    monthYearTo: exp.month_year_to || exp.monthYearTo || "",
    reasonForLeaving: exp.reason_for_leaving || exp.reasonForLeaving || "",
    experienceLetterProvided:
      exp.experience_letter_provided === true ||
      exp.experience_letter_provided === "T" ||
      exp.experienceLetterProvided ||
      false,
  }));

  setDataList(normalizedRows);
  // Keep the input row empty for the next add action.
  setFormData(emptyForm);
}, [experienceData]);





  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "monthYearFrom" || name === "monthYearTo") {
      setValidationErrors((prev) => ({
        ...prev,
        [name]: isFutureDate(value) ? "This date cannot be in the future." : "",
      }));
    }
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

 const handleAdd = () => {
   const { organization, monthYearFrom, monthYearTo, reasonForLeaving } =
     formData;

   if (!organization || !monthYearFrom || !monthYearTo || !reasonForLeaving) {
     alert("Please fill all fields before adding.");
     return;
   }

   if (isFutureDate(monthYearFrom) || isFutureDate(monthYearTo)) {
     setValidationErrors({
       monthYearFrom: isFutureDate(monthYearFrom)
         ? "This date cannot be in the future."
         : "",
       monthYearTo: isFutureDate(monthYearTo)
         ? "This date cannot be in the future."
         : "",
     });
     return;
   }

   if (new Date(monthYearTo) < new Date(monthYearFrom)) {
     alert("Month/Year To cannot be earlier than Month/Year From.");
     return;
   }

   const newItem = {
     srNo: dataList.length + 1,
     ...formData,
   };

   const updatedList = [...dataList, newItem];

   setDataList(updatedList); // ✅ update table
   setExperienceData(updatedList); // ✅ update parent (for save)
   sessionStorage.setItem(
     "staff_registration_experience",
     JSON.stringify(
       updatedList.map((item) => ({
         previous_company_worked: item.organization,
         month_year_from: item.monthYearFrom,
         month_year_to: item.monthYearTo,
         reason_for_leaving: item.reasonForLeaving,
         experience_letter_provided: item.experienceLetterProvided,
       }))
     )
   );

   // Reset input
   setFormData(emptyForm);
    setValidationErrors({});
 };




  return (
    <div className="container-fluid my-4">
      {/* <h5>Previous Experience Details</h5> */}
      <div className="table-responsive">
        <table className="table table-bordered">
          <thead className="thead-light">
            <tr>
              <th>Sr.No</th>
              <th>Organization</th>
              <th>Month/Year From</th>
              <th>Month/Year To</th>
              <th>Reason for Leaving</th>
              <th>Experience Letter Provided</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {dataList.map((data, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{data.organization}</td>
                <td>{data.monthYearFrom}</td>
                <td>{data.monthYearTo}</td>
                <td>{data.reasonForLeaving}</td>
                <td className="text-center">
                  <input
                    type="checkbox"
                    checked={data.experienceLetterProvided}
                    readOnly
                  />
                </td>
                <td></td>
              </tr>
            ))}
            {/* Input row */}
            <tr>
              <td>{dataList.length + 1}</td>
              <td>
                <input
                  className="form-control"
                  name="organization"
                  value={formData.organization}
                  onChange={handleChange}
                />
              </td>
              <td>
                <input
                  className={`form-control ${validationErrors.monthYearFrom ? "is-invalid" : ""}`}
                  type="date"
                  name="monthYearFrom"
                  value={formData.monthYearFrom}
                  onChange={handleChange}
                />
                {validationErrors.monthYearFrom && (
                  <div className="invalid-feedback d-block">
                    {validationErrors.monthYearFrom}
                  </div>
                )}
              </td>
              <td>
                <input
                  className={`form-control ${validationErrors.monthYearTo ? "is-invalid" : ""}`}
                  type="date"
                  name="monthYearTo"
                  value={formData.monthYearTo}
                  onChange={handleChange}
                />
                {validationErrors.monthYearTo && (
                  <div className="invalid-feedback d-block">
                    {validationErrors.monthYearTo}
                  </div>
                )}
              </td>
              <td>
                <input
                  className="form-control"
                  name="reasonForLeaving"
                  value={formData.reasonForLeaving}
                  onChange={handleChange}
                />
              </td>
              <td className="text-center">
                <input
                  type="checkbox"
                  name="experienceLetterProvided"
                  checked={formData.experienceLetterProvided}
                  onChange={handleChange}
                />
              </td>
              <td>
                <button
                  className="btn btn-primary btn-sm w-100"
                  onClick={handleAdd}
                >
                  Add
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-start mb-3 mt-3"></div>
      
      </div>
    
  );
};

export default PreviousExperience;






